/**
 * @file Appointment Status Constants
 *
 * Single source of truth for appointment status values, labels, colors,
 * and transition rules. Used by server, web client, and mobile app.
 *
 * Status flow:
 *   AGENDADA → CONFIRMADA → COMPLETADA
 *      |            |
 *   CANCELADA   CANCELADA / NO_ASISTIO
 */

// ── Status groups ──────────────────────────────────────────────

export const FINAL_STATUSES = ["COMPLETADA", "CANCELADA", "NO_ASISTIO"];
export const ACTIVE_STATUSES = ["AGENDADA", "CONFIRMADA"];
export const ALL_STATUSES = ["AGENDADA", "CONFIRMADA", "COMPLETADA", "CANCELADA", "NO_ASISTIO"];

// ── Spanish labels ─────────────────────────────────────────────

export const STATUS_LABELS = {
  AGENDADA: "Agendada",
  CONFIRMADA: "Confirmada",
  COMPLETADA: "Completada",
  CANCELADA: "Cancelada",
  NO_ASISTIO: "No asistió",
};

// ── Colors: MUI color names (web) ──────────────────────────────

export const STATUS_MUI_COLORS = {
  AGENDADA: "info",
  CONFIRMADA: "primary",
  COMPLETADA: "success",
  CANCELADA: "error",
  NO_ASISTIO: "warning",
};

// ── Colors: hex values (mobile) ────────────────────────────────

export const STATUS_HEX_COLORS = {
  AGENDADA: "#42A5F5",
  CONFIRMADA: "#5C6BC0",
  COMPLETADA: "#66BB6A",
  CANCELADA: "#E53935",
  NO_ASISTIO: "#FFA726",
};

// ── Valid transitions ──────────────────────────────────────────

export const VALID_TRANSITIONS = {
  AGENDADA: ["CONFIRMADA", "COMPLETADA", "CANCELADA"],
  CONFIRMADA: ["COMPLETADA", "CANCELADA"],
};
